import { combineReducers } from "redux";
import loginReducer from "./user_login_auth_reducer.js/login_reducer";
import rolesReducer from "./admin_module_reducer/roles_reducer";
import userReducer from "./admin_module_reducer/user_reducer";
import reportReducer from "./reports_reducer/reports_reducer";
import juryProfileReducer from "./admin_module_reducer/juryProfile_reducer";
import awardEventReducer from "./admin_module_reducer/awardEvent_reducer";
import applicationForm_Reducer from "./applicationModule_reducer/applicationForm_reducer";
import adminModuleReducer from "./admin_module_reducer/admin_module_reducer";
import circularReducer from "./admin_module_reducer/circularReducer";
import receipt_reducer from "./accounts_reducer/receipt_reducer";
import applicationMatrixReducer from "./admin_module_reducer/matrix_reducer";
import cmsReducer from "./cms_reducer/cms_reducer";

export default combineReducers({
  loginReducer, rolesReducer, userReducer,
  reportReducer, juryProfileReducer, awardEventReducer,
  applicationForm_Reducer, adminModuleReducer,
  circularReducer, receipt_reducer,
  applicationMatrixReducer, cmsReducer
});
